import { ApolloClient } from 'apollo-client';

export abstract class Resource {
  protected readonly client: ApolloClient<object>;

  public constructor(client: ApolloClient<object>) {
    this.client = client;
  }
}
